import React from 'react';

import { DEFAULT_HOUR_MINUTE_DISPLAY } from 'pages/TrackAndTrace/config';
import { DATE_DISPLAY_FORMAT } from '../container-config';

export function DisplayTimeRange({ startDateTime, endDateTime }) {
  if (!startDateTime) return null;
  const startDate = startDateTime.format(DATE_DISPLAY_FORMAT);

  const formatStartTime = !endDateTime
    ? `${DEFAULT_HOUR_MINUTE_DISPLAY} z`
    : DEFAULT_HOUR_MINUTE_DISPLAY;
  const startTime = startDateTime.format(formatStartTime);

  const startDateTimeDisplay = ` · ${startDate} · ${startTime}`;

  if (!endDateTime) {
    return <>{startDateTimeDisplay}</>;
  }

  const endTime = endDateTime.format(`${DEFAULT_HOUR_MINUTE_DISPLAY} z`);

  return (
    <>
      {startDateTimeDisplay}-{endTime}
    </>
  );
}
